import { MigrationType } from "../models/Statistics/MigrationType";

/** Migration types that support priority recalculation (folder types are excluded). */
export const RECALCULATION_MIGRATION_TYPES: MigrationType[] = [
  MigrationType.CasesMigration,
  MigrationType.IntakesMigration,
  MigrationType.ProvidersMigration,
  MigrationType.TemplatesMigration,
  MigrationType.FirmDocumentsMigration,
];

/** Shared danger-modal warnings for recalculation, reused by the standalone page and the SQL scripts page. */
export const RECALCULATION_WARNINGS: string[] = [
  "The migration queue for the selected migration types will be paused on this organization until recalculation completes.",
  "Recalculation runs asynchronously in the background and may take several minutes depending on the number of files.",
  "Triggered events are durable — you can close this page; progress will be reflected in the status panel.",
];
